import { useParams } from 'react-router-dom'

import { TableCard, TableEmptyState } from '../../../../components'
import { EnderecosHeading } from './components/header/EnderecosHeading'
import { isOrigemEndereco } from './core/_origem'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EnderecosTable } from './table/EnderecosTable'

const EnderecosList = () => {
  const { origem } = useParams<{ origem: string }>()

  if (!isOrigemEndereco(origem)) {
    return (
      <TableCard>
        <TableEmptyState
          title='Origem não identificada'
          description='Não foi possível identificar a origem desta lista de endereços.'
        />
      </TableCard>
    )
  }

  return (
    <>
      <EnderecosHeading origem={origem} />
      <TableCard>
        <EnderecosTable />
      </TableCard>
    </>
  )
}

export const EnderecosListWrapper = () => (
  <QueryResponseProvider>
    <EnderecosList />
  </QueryResponseProvider>
)
